import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "AddGenuineProduct" })
export default class AddGenuineProduct extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = {};
    public certificateUrl: string = null;
    public validationErrors: any[] = [];

    get isGenuineProductFormVisible() {
        return this.$store.getters["myProductStore/isGenuineProductFormVisible"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly isCompleted: boolean;

    @Watch("isGenuineProductFormVisible") onIsGenuineProductFormVisibleChanged(newValue: boolean) {
        if (newValue) {
            document.body.classList.add("overflow");
            (<any>this).$refs.genuineProductModal.classList.add("show");
        } else {
            document.body.classList.remove("overflow");
            (<any>this).$refs.genuineProductModal.classList.remove("show");
        }
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        this.formData.km = this.formData.km == "" ? null : this.formData.km;

        try {
            const result = (await Axios.post(this.routes.MyBremboPartsProduct_GenuineSubmitForm, this.formData)).data;

            this.isSuccess = true;
            this.certificateUrl = result.certificateUrl;

            GTagHelper.sendCustomEvent("form_submit", { genuine: "success" });
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public setAnalytics() {
        GTagHelper.sendCustomEvent("file_download", { genuine: "download_certificate", genuine_certificate_code: this.formData.bremboCode });
    }

    public close() {
        this.validationErrors = [];
        this.formData = {};
        this.certificateUrl = null;
        this.$store.commit("myProductStore/setGenuineProductFormVisible", false);
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
}